// src/pages/Home.js
import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import WhoWeAre from '../components/WhoWeAre';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import AnimatedSection from '../components/AnimatedSection';

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <AnimatedSection>
        <WhoWeAre />
      </AnimatedSection>
      <AnimatedSection delay={0.2}>
        <Testimonials />
      </AnimatedSection>
      <Footer />
    </>
  );
};

export default Home;